export type TeamLogoProps = {
  logoUrl?: string
  isPlace?: ETeamLogo
}

export enum ETeamLogo {
  mainPage = 'mainPage',
  eventCompleted = 'eventCompleted'
}
